An array of `Location` identifiers.

Scheme requirements:

- The `seekAnz` scheme has a maximum of one element.
